/*
 * action types
 */
export const USER_LOGIN = 'USER_LOGIN';
export const SET_USER_STATE = 'SET_USER_STATE';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const GET_USER_DATA = 'GET_USER_DATA';
export const GET_COMMON_DATA = 'GET_COMMON_DATA';
export const HOME_PAGES = 'HOME_PAGES';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
